<div id="actionElements">
	<a
		(click)="backfillDigitalNixie()"
		class="btn btn-save btn-sm inline-add-btn mt-2"
		[class.disabled]="backfillRunning"
	>{{ backfillRunning ? 'Generating Digital Nixie Backfill...' : 'Backfill Digital Nixie File' }}</a>
</div>
<pcg-table
	#table
	[pcgSort]="[['vendorName', 'desc']]"
	[multipleSearch]="false"
	dataSource="api/Nixies/Nixies/GetNixieList"
	[columnDefs]="columns"
>
	<ng-container cdkColumnDef="vendorName">
		<th pcg-sort-header cdk-header-cell *cdkHeaderCellDef>Client</th>
		<td cdk-cell *cdkCellDef="let row">{{ row.vendorName }}</td>
	</ng-container>
	<ng-container cdkColumnDef="uploadFileName">
		<th pcg-sort-header cdk-header-cell *cdkHeaderCellDef>Nixie File Upload</th>
		<td cdk-cell *cdkCellDef="let row">
			<pcg-upload-button
				uploadUrl="api/Nixies/Nixies/UploadNixie"
				submitUrl="api/Nixies/Nixies/SubmitNixie"
				deleteUrl="api/Nixies/Nixies/DeleteNixie"
				[fileName]="row.uploadFileName"
				[id]="row.vendorId"
				(updateTable)="table.ajaxReload(); uploadsTable.ajaxReload()"
			></pcg-upload-button>
		</td>
	</ng-container>
</pcg-table>

<h4 class="mt-4">Physical Return Mail Counts</h4>

<div class="clearfix">
	<div id="pageActions">
		<button
			(click)="uploadsTable.getExcel('Physical Return Mail Counts')"
			ngbTooltip="Export to Excel"
			class="export-to-excel page-action float-right"
		></button>
	</div>
</div>

<pcg-table-filter id="nixieUploadFilters">
	<div class="filters-ctnr">
		<div class="filter-block">
			<label for="submittedDate" class="for">Submitted Date</label>
			<pcg-date-range
				labelForId="submittedDate"
				[(dateRange)]="filters.dateRange"
				(dateRangeChange)="uploadsTable.ajaxReload()"
			></pcg-date-range>
		</div>
	</div>
</pcg-table-filter>

<pcg-table
	#uploadsTable
	[ajaxData]="filters"
	[filterId]="'nixieUploadFilters'"
	[canResetFilters]="true"
	[canGlobalSearch]="false"
	[pcgSort]="[['submittedDate', 'desc']]"
	[multipleSearch]="false"
	dataSource="api/Nixies/Nixies/GetNixieUploadList"
	[columnDefs]="uploadColumns"
	(tableReceive)="totals = $event.value"
>
	<ng-container cdkColumnDef="submittedDate">
		<th pcg-sort-header cdk-header-cell *cdkHeaderCellDef>Nixie File Submitted Date</th>
		<td cdk-cell *cdkCellDef="let row">{{ row.submittedDate | date: 'shortDate' }}</td>
		<td cdk-footer-cell *cdkFooterCellDef>Totals</td>
	</ng-container>
	<ng-container cdkColumnDef="nystaRecords">
		<th pcg-sort-header cdk-header-cell *cdkHeaderCellDef>NYSTA Records</th>
		<td cdk-cell *cdkCellDef="let row">{{ row.nystaRecords | number }}</td>
		<td cdk-footer-cell *cdkFooterCellDef>{{ totals?.nystaRecords | number }}</td>
	</ng-container>
	<ng-container cdkColumnDef="nysbaRecords">
		<th pcg-sort-header cdk-header-cell *cdkHeaderCellDef>NYSBA Records</th>
		<td cdk-cell *cdkCellDef="let row">{{ row.nysbaRecords | number }}</td>
		<td cdk-footer-cell *cdkFooterCellDef>{{ totals?.nysbaRecords | number }}</td>
	</ng-container>
</pcg-table>
